module.exports = __webpack_public_path__ + "img/itinerary_map_mobile.bda9e014.png";